import React, { useState } from "react";
// SCSS
import "./experience.scss";
//Assets
import expImgBlack from '../../assets/experience/expBlack.png'

const ExperienceCard = ({ id, company, jobtitle, startYear, endYear, desc1, desc2, desc3, desc4 }) => {

    const [isActive, setIsActive] = useState(false);
    const [isClick, setIsClick] = useState(false);

    return (
        <div className={`experience-card ${!isClick ? 'cursor-plus' : 'cursor-minus'}`}
            onClick={() => { setIsActive(!isActive); setIsClick(!isClick) }}
        >
            <div className="expcard-img">
                <img src={expImgBlack} alt="" />
            </div>
            <div className="expcard-details">
                <h6 >{startYear} - {endYear}</h6>
                <h4 >{jobtitle}</h4>
                <h5 >{company}</h5>
                {isActive &&
                    <div className="expcard-accordion">
                        <ul>
                            <li>{desc1}</li>
                            <li>{desc2}</li>
                            <li>{desc3}</li>
                            <li>{desc4}</li>
                        </ul>
                    </div>}
            </div>

        </div>
    )
}

export default ExperienceCard

